<template>
  <component
    :is="component"
    v-if="component"
    v-bind="data"
  />
</template>
<script lang="ts" setup>
import { defineAsyncComponent } from 'vue';

const props = defineProps({
  type: {
    type: String,
    required: false,
    default: 'div'
  },
  data: {
    type: Object,
    required: false,
    default: () => {}
  }
});
const component = shallowRef(null);
const componentName = 'Dn' + props.type.replace(/_([a-z])/g, function (_, letter) {
  return letter.toUpperCase();
}).replace(/^([a-z])/, function (_, letter) {
  return letter.toUpperCase();
});

component.value = defineAsyncComponent(async () => {
  try {
    return await import(`~/components/${componentName}/${componentName}.vue`);
  } catch (e) {
    // eslint-disable-next-line no-console
    console.warn(`Component ${componentName} not implemented`, e);
    return null;
  }
});
</script>
